/**
 * Site-wide destinations and status. Lightning Learn is not yet on the App
 * Store, so no button links to a store listing. When the listing is live, set
 * APP_STORE_URL and add a store link where needed.
 */
export const APP_STORE_URL: string | null = null

/** Every "Try Free Adventure" CTA opens the free in-browser sample lesson. */
export const SAMPLE_HREF = '/adventure'

export const APP_STATUS = 'Coming to iPhone'

export const SUPPORT_EMAIL = 'support@lightninglearn.io'

export const OPERATOR_NAME = 'Black Comet Labs, LLC'
